import "./index.scss";
import { useRef, useEffect } from "react";
import { BaSePopupButton } from "@base/react";
import logoArrow from "../../assets/images/icons/arrow-up-black.svg";

const AccordionGraphics = ({
  title,
  weight,
  children,
  boxShadow = "",
  canClose = true,
  titleSize = "",
  isOpen = false,
  tooltip = null,
  onToggle = () => {},
  marginBottom = "8px",
}) => {
  const panelRef = useRef(null);

  const toggleAccordion = () => {
    if (canClose) {
      onToggle();
    }
  };

  useEffect(() => {
    const panel = panelRef.current;
    if (panel) {
      if (isOpen) {
        panel.style.gridTemplateRows = "1fr";
      } else {
        panel.style.gridTemplateRows = "0fr";
      }
    }
  }, [isOpen]);

  return (
    <div
      className="accordion-graphics-container"
      style={{
        borderRadius: "4px",
        boxShadow: boxShadow ? "0 1px 4px 0 rgba(20, 46, 82, 0.20)" : "",
        marginBottom: marginBottom ? marginBottom : "",
      }}
    >
      <div
        className={`header-accordion ${isOpen ? "active" : ""}`}
        style={{ cursor: !canClose ? "default" : "pointer" }}
        onClick={toggleAccordion}
      >
        <span className="header-content">
          <div className="header-content-left">
            <p
              style={{
                fontSize: titleSize ? `${titleSize}px` : "",
                fontWeight: weight ? weight : "",
              }}
            >
              {title}
            </p>
            {tooltip && (
              <BaSePopupButton
                title={tooltip.title}
                type={tooltip.type}
                direction={tooltip.direction}
                message={
                  <span dangerouslySetInnerHTML={{ __html: tooltip.message }} />
                }
                alertSize={tooltip.alertSize}
              />
            )}
          </div>
          {canClose ? (
            <img
              src={logoArrow}
              className={`${isOpen ? "rotate-up" : "rotate-down"}`}
              alt="ícone de seta"
            />
          ) : (
            ""
          )}
        </span>
      </div>

      <div className={`panel ${isOpen ? "open" : ""}`} ref={panelRef}>
        <div className="panel-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AccordionGraphics;
